/*
 * GA4 用 dataLayer 送出。
 * 対応イベント: add_to_wishlist / login / sign_up / select_promotion
 *
 * DOM 側の契約:
 *   [data-ga4-datalayer]  ページ文脈(ログイン状態・通貨・ページ表示時イベント)
 *   [data-ga4-item]       商品1件分のデータ。data-ga4-item-* に値を持つ
 *   [data-ga4-promotion]  バナー。data-ga4-promotion-* / data-ga4-creative-* / data-ga4-location-id
 */
(function () {
  if (window.relikeGa4) return;

  var SELECTOR = {
    config: '[data-ga4-datalayer]',
    item: '[data-ga4-item]',
    promotion: '[data-ga4-promotion]',
  };
  var PENDING_LOGIN_KEY = 'relike_ga4_pending_login';
  var PAGE_EVENT_KEY_PREFIX = 'relike_ga4_page_event_';

  function layer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function push(eventName, payload) {
    var data = payload || {};
    var dl = layer();
    if (data.ecommerce) dl.push({ ecommerce: null });
    var message = { event: eventName };
    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) message[key] = data[key];
    }
    dl.push(message);
  }

  function config() {
    return document.querySelector(SELECTOR.config);
  }

  function currency() {
    var el = config();
    return (el && el.dataset.currency) || 'JPY';
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      /* プライベートモードなどでは黙って諦める */
    }
  }

  function clearSession(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      /* noop */
    }
  }

  /* 数値 ID と gid://shopify/Product/123 の両方を数値部分に寄せる */
  function normalizeId(value) {
    var matched = String(value == null ? '' : value).match(/(\d+)\s*$/);
    return matched ? matched[1] : '';
  }

  function toItem(element) {
    if (!element) return null;
    var data = element.dataset;
    var item = {
      item_id: data.ga4ItemId || '',
      item_name: data.ga4ItemName || '',
      quantity: 1,
    };
    if (data.ga4ItemBrand) item.item_brand = data.ga4ItemBrand;
    if (data.ga4ItemCategory) item.item_category = data.ga4ItemCategory;
    if (data.ga4ItemVariant) item.item_variant = data.ga4ItemVariant;
    if (data.ga4ItemPrice) item.price = Number(data.ga4ItemPrice);
    if (data.ga4ItemCode) item.item_code = data.ga4ItemCode;
    if (data.ga4ItemSku) item.rsin = data.ga4ItemSku;
    return item;
  }

  /* お気に入り追加。Wishlist King が document に発行する DOM イベントを拾う */
  function bindWishlist() {
    document.addEventListener('wk:wishlist:add:success', function (event) {
      var detail = (event.detail && event.detail.data) || {};
      var productId = normalizeId(detail.productId);
      var element = productId
        ? document.querySelector(SELECTOR.item + '[data-ga4-item-id="' + productId + '"]')
        : null;
      var item = toItem(element) || { item_id: productId, quantity: 1 };
      var payload = {
        ecommerce: {
          currency: currency(),
          value: item.price || 0,
          items: [item],
        },
      };
      if (item.item_code) payload.item_code = item.item_code;
      if (item.rsin) payload.rsin = item.rsin;
      push('add_to_wishlist', payload);
    });
  }

  /* ログイン。送信時に印を付け、ログイン済みで戻ってきた最初のページで送る */
  function bindLogin() {
    var el = config();
    if (el && el.dataset.ga4LoginPage === 'true') {
      document.addEventListener(
        'submit',
        function (event) {
          var form = event.target;
          if (!form || !form.action) return;
          if (form.action.indexOf('/account/login') === -1) return;
          writeSession(PENDING_LOGIN_KEY, '1');
        },
        true
      );
    }

    if (!el || el.dataset.loggedIn !== 'true') return;
    if (readSession(PENDING_LOGIN_KEY) !== '1') return;
    clearSession(PENDING_LOGIN_KEY);
    push('login', { method: 'shopify' });
  }

  /* 会員登録などのページ表示時イベント。リロードでの二重送出を抑える */
  function firePageEvent() {
    var el = config();
    if (!el) return;
    var name = el.dataset.ga4PageEvent;
    if (!name) return;
    var key = PAGE_EVENT_KEY_PREFIX + name;
    if (readSession(key) === window.location.pathname) return;
    writeSession(key, window.location.pathname);
    push(name, { method: 'shopify' });
  }

  function promotionPayload(element) {
    var data = element.dataset;
    var ecommerce = {};
    if (data.ga4PromotionId) ecommerce.promotion_id = data.ga4PromotionId;
    if (data.ga4PromotionName) ecommerce.promotion_name = data.ga4PromotionName;
    if (data.ga4CreativeName) ecommerce.creative_name = data.ga4CreativeName;
    if (data.ga4CreativeSlot) ecommerce.creative_slot = data.ga4CreativeSlot;
    if (data.ga4LocationId) ecommerce.location_id = data.ga4LocationId;
    return { ecommerce: ecommerce };
  }

  /* バナークリック */
  function bindPromotionClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var promotion = target.closest(SELECTOR.promotion);
        if (!promotion) return;
        push('select_promotion', promotionPayload(promotion));
      },
      true
    );
  }

  function init() {
    bindWishlist();
    bindLogin();
    firePageEvent();
    bindPromotionClicks();
  }

  window.relikeGa4 = { push: push };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
